import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'
import { useDispatch } from 'react-redux'
import AdminRoutes from './routes/AdminRoutes';
import UsereRoutes from './routes/UserRoutes'
import { getMyProfile } from './store/slices/authSlice'
import store from './store/store'

const ScrollToTopOnRouteChange = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
};

// GA4 page view tracking for SPA route changes
const GAPageTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-7BSN0GG04R', {
        page_path: pathname + search,
        page_title: document.title,
      });
    }
  }, [pathname, search]);

  return null;
};

const App = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    let hasToken = false
    try {
      const raw = localStorage.getItem('token')
      hasToken = Boolean(raw && JSON.parse(raw))
    } catch {
      hasToken = false
    }
    if (hasToken) {
      store.dispatch(getMyProfile())
    }
  }, [dispatch])

  useEffect(() => {
    const lockLightTheme = (node) => {
      if (!node) return
      node.style.setProperty('color-scheme', 'only light', 'important')
      node.style.setProperty('forced-color-adjust', 'none', 'important')
      node.style.setProperty('background-color', '#ffffff', 'important')
    }

    lockLightTheme(document.documentElement)
    lockLightTheme(document.body)
    lockLightTheme(document.getElementById('root'))
    document.body.style.setProperty('color', '#0a0a0a', 'important')
    const themeMeta = document.querySelector('meta[name="theme-color"]')
    themeMeta?.setAttribute('content', '#9c5844')
  }, [])

  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <GAPageTracker />
      <ToastContainer
        theme="light"
        style={{
          top: '20px',
          width: 'auto',
          maxWidth: '90%'
        }}
      />
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/*" element={<UsereRoutes />} />
      </Routes>
    </Router>
  );
};

export default App;